<template>
	<el-row slot="title" style="padding:0;" type="flex" align="middle">
		<el-col :span="12" style="font-size:20px">{{title}}</el-col>
		<el-col :span="12" style="text-align:right">
			<el-button type="primary" @click="$emit('commit')">提交</el-button>
			<el-button @click="$emit('cancel')">取消</el-button>
		</el-col>
	</el-row>
</template>
<script>
export default {
	props:['title'],
	
}
</script>


// WEBPACK FOOTER //
// src/components/el-form-header.vue